// 半角換算で文字列の長さを取得する
export const get2byteLength = (str: string): number => {
  let count = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    // https://www.ssec.wisc.edu/~tomw/java/unicode.html
    if (
      (charCode >= 0x3000 && charCode <= 0x9fff) || // ひらがな、カタカナ、漢字など
      (charCode >= 0xff01 && charCode <= 0xff60) || // 全角記号、数字、アルファベット
      (charCode >= 0xffe0 && charCode <= 0xffe6)
    ) {
      // 全角円マークなど
      count += 2;
    } else {
      // 半角文字の場合
      count += 1;
    }
  }
  return count;
};

/**
 * PostgreSQL の LIKE / ILIKE パターンとして解釈されないよう、ワイルドカード文字を
 * エスケープする。ユーザー入力をパターンに埋め込む場合は必ず通すこと
 *
 * 例: `foo%` をそのまま渡すと `fooX` にも一致してしまう
 */
export const escapeLikePattern = (value: string): string =>
  value.replace(/[\\%_]/g, (matched) => `\\${matched}`);
